<template>
	<div class="company">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">新增开票公司</el-button>
		</div>
		<div class="tablebox">
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="name" fixed="left" label="公司名称" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="nssbh" label="纳税识别号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="address" label="地址" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="mobile" label="电话号码" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="remark" label="备注" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onupdate(scope.row)">编辑</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog :title="ruleForm.id == 0?'新增开票公司':'编辑开票公司'" :visible.sync="show" width="50%" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
					<el-form-item label="公司名称" prop="name" >
						<el-input v-model="ruleForm.name" placeholder="请输入公司名称"></el-input>
					</el-form-item>
					
					<el-form-item label="纳税识别号" prop="nssbh">
						<el-input v-model="ruleForm.nssbh" placeholder="请输入纳税识别号"></el-input>
					</el-form-item>
					
					<el-form-item label="地址" prop="address">
						<el-input type="textarea" placeholder="请输入公司地址" v-model="ruleForm.address" :rows="2">
						</el-input>
					</el-form-item>

					<el-form-item label="电话号码" prop="mobile">
						<el-input v-model="ruleForm.mobile" placeholder="请输入电话号码"></el-input>
					</el-form-item>

					<el-form-item label="备注">
						<el-input type="textarea" placeholder="" v-model="ruleForm.remark" maxlength="100" show-word-limit
							:rows="2">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: 'Company',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,

				show: false,
				ruleForm: {
					id: 0,
					name: "",
					nssbh: "",
					address: "",
					mobile: "",
					remark: "",
				},

				rules: {
					name: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					nssbh: [{
						required: true,
						message: '请输入纳税识别号',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请输入电话号码',
						trigger: 'blur'
					}]
				}
			}
		},

		mounted() {
			this.onlist();
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onlist() {
				var obj = {};
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/user_invoice_company_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.show = true;
			},

			onclose() {
				this.show = false;
				this.ruleForm = {
					id: 0,
					name: "",
					nssbh: "",
					address: "",
					mobile: "",
					remark: "",
				};
			},
			
			onupdate(obj) {
				for (let key in this.ruleForm) {
					this.ruleForm[key] = obj[key];
				}
				this.show = true;
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						this.$axios.post('api/user/user_invoice_company_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.company {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 104px);
	}
	
	.tablediv {
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/company.vue